import imageurls from 'commons/image-urls.json';
import addDomainToPath from 'commons/addDomainToPath';

import collectionsData from './collectionsData';
import { collectionOrder } from './collectionOrder';

const getModularCollectionImage = collectionName =>
  addDomainToPath(`${imageurls.modularCollectionsPath}${collectionName}.png`);

export const prepareCollectionDataStatic = collectionQueryData => {
  if (!collectionQueryData) return [];

  const finalData = collectionQueryData
    .map(collection => {
      const collectionName = collection.primaryProduct.name.split(
        ' Modular'
      )[0];
      if (collection.products.length === 0) return null;
      return {
        id: collection.primaryProduct.id,
        name: collectionName,
        description: collection?.collectionDescription || '',
        image:
          collectionsData[collectionName.toLowerCase()]?.image ||
          getModularCollectionImage(collectionName),
        link: collection.modularCollectionSlug,
        productLink: collection.primaryProduct.slug,
        products: collection.products,
        thumbnail: collectionsData[collectionName.toLowerCase()]?.thumbnail,
      };
    })
    .filter(v => !!v);
  return finalData.sort(
    (a, b) => collectionOrder.indexOf(a.name) - collectionOrder.indexOf(b.name)
  );
};
